import { StyleFunctionProps } from '@telescope/cassini-ui';
import { defineStyle } from '@chakra-ui/styled-system';

const variantSolid = defineStyle((props) => {
  const { errorColorScheme: c } = props.theme.settings;

  return {
    field: {
      borderWidth: 1,
      bg: '#fff',
      _hover: {
        bg: '#ffffff80',
        _disabled: {
          bg: 'initial',
        },
      },
      _active: { 
        bg: '#ffffff80'
      },
      _focusVisible: { borderColor: 'focus', boxShadow: '0 0 0 1px var(--cassini-colors-focus)' },
      _invalid: {
        borderColor: `${c}.500`,
        boxShadow: `0 0 0 1px ${c}.500`,
      }
    }    
  };
});

export const inputTheme = {
  variants: {
    outline: (props: StyleFunctionProps) => {
      const { errorColorScheme: c } = props.theme.settings;

      return ({
        field: {
          _focusVisible: { borderColor: 'focus', boxShadow: '0 0 0 1px var(--cassini-colors-focus)' },
          _invalid: {
            borderColor: `${c}.500`,
            boxShadow: `0 0 0 1px ${c}.500`,
          }
        },
      })
    },
    solid: variantSolid
  },
  defaultProps: {
    variant: 'solid'
  }
};